var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column vh-100 bg-light",attrs:{"id":"app"}},[_c('header-bar'),_c('div',{staticClass:"flex-grow-1 d-flex justify-content-center align-items-center"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }